import { newToolFilterOAuthMcp } from "../oauth.ts";

export const windsorMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://windsor.ai/wp-content/uploads/2020/02/favicon-310.png",
  url: "https://mcp.windsor.ai",
  label: "Windsor.ai",
});
